import { ReactNode } from 'react';
import { useRealtimeSync } from '@/hooks/useRealtimeSync';

interface RealtimeProviderProps {
  children: ReactNode;
}

export function RealtimeProvider({ children }: RealtimeProviderProps) {
  useRealtimeSync();
  return <>{children}</>;
}